import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import IconBtn from '../../common/IconBtn'
import { TbEdit } from "react-icons/tb";

const MyProfile = () => {
  const {user} = useSelector((state)=>state.profile)
  const navigate = useNavigate()

  const personalDetails = [
    {
      title:"First Name",
      detail:user?.firstName
    },
    {
      title:"Last Name",
      detail:user?.lastName
    },
    {
      title:"Email",
      detail:user?.email
    },
    {
      title:"Phone number",
      detail:user?.additionalDetails?.contactNumber,
      alterText:"Add your contact number"
    },
    {
      title:"Date of birth",
      detail:user?.additionalDetails?.dateOfBirth,
      alterText:"Add your date of birth"
    },
    {
      title:"Gender",
      detail:user?.additionalDetails?.gender,
      alterText:"Add your gender"
    }
  ]
  return (
    <div >
       <h1 className="mb-14 text-3xl font-medium text-richblack-5">
         My Profile
       </h1>
       {/* section 1  */}
       <div className="flex items-center justify-between rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12">
        <div className="flex items-center gap-x-4">
          <img 
          src={user?.image}
          alt={`profile - ${user?.firstName}`} 
          className="aspect-square w-[78px] rounded-full object-cover"
          />
          <div className='space-y-1'>
            <p className="text-lg font-semibold text-richblack-5">{user?.firstName + " "+user?.lastName}</p>
            <p className="text-sm text-richblack-300">{user?.email}</p>
          </div>
        </div>
        <IconBtn 
        onclick={()=>{navigate('/dashboard/settings')}}
        text={'Edit'}
        >
          <TbEdit/>
        </IconBtn>
       </div>

       {/* section 2  */}
       <div className="my-10 flex flex-col gap-y-10 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12">
         <div className="flex w-full items-center justify-between">
           <p className='text-lg font-semibold text-richblack-5'>About</p>
           <IconBtn
           text={"Edit"}
           onclick={()=>{navigate('/dashboard/settings')}}
            >
               <TbEdit/>
            </IconBtn>
         </div>
         <p  
          className={`${
            user?.additionalDetails?.about
              ? "text-richblack-5"
              : "text-richblack-400"
          } text-sm font-medium`}
         >{user?.additionalDetails?.about ?? "Write something about yourself"}
         </p>
       </div>

       {/* section 3  */}
       <div className="my-10 flex flex-col gap-y-10 rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-8 px-12">
        <div className="flex w-full items-center justify-between">
          <p className="text-lg font-semibold text-richblack-5">Personal Details</p>
          <IconBtn
           text={"Edit"}
           onclick={()=>{navigate('/dashboard/settings')}}
            >
               <TbEdit/>
            </IconBtn>
        </div>
        <div className='grid grid-cols-2 gap-x-12 w-full max-w-[500px]'>
       {  
           personalDetails.map((field,index)=>(
           <div key={index}>
            <p className=" text-sm text-richblack-600">{field?.title}</p>
            <p className="mb-2 text-sm font-medium text-richblack-5">{field?.detail ?? field.alterText}</p>
           </div>

          ))
          }
        </div>
       </div>
    </div>
  )
}

export default MyProfile